<template>
<div id="subscriptions">
  <div
    v-if="!noNav"
  >
    <h2>Purchased Subscriptions</h2>

    <subscription-nav />

    <hr />
  </div>

  <subscription-search
    v-if="!noSearch"
  />

  <div
    class="subscription-key paged-key"
    v-if="!noKey"
  >
    <p>
      <span
        class="paged-key-label"
      >
        Subscription key
      </span>

      <span class="badge badge-success">
        Active
      </span>

      <span class="badge badge-primary">
        Future Subscription
      </span>

      <span class="badge badge-warning">
        Expiry Looming
      </span>

      <span class="badge badge-danger">
        Expiry Imminent
      </span>

      <span class="badge badge-dark">
        Expired
      </span>
    </p>
  </div>

  <pagination
    ref="pagination"
    :resourceUrl="subscriptionUrl"
    :pageResponse="pageResponse"
    :pageSize="$root.defaultPageSize"
    orderBy="created_at"
    orderType="DESC"
    preserveHistory
  >
    <template
      slot="paged_item"
      slot-scope="item"
    >
      <router-link
        :class="$root.listItemClasses + ' ' + subscriptionClass(item.status)"
        :to="{
          name: 'subscription',
          params: {
            subscriptionId: item.id
          }
        }"
      >
        {{ formattedSubscriptionDate(item.start_ts) }} {{ item.email }} ({{ item.purchasable_item.attributes.name }})
        <span
          v-if="item.purchase"
        >
          {{ isGift(item) ? $root.giftIcon : '' }}
        </span>
      </router-link>
    </template>
  </pagination>
</div>
</template>

<script>
import Pagination from 'sai-vue-kaminari'

import SubscriptionNav from '@/components/SubscriptionNav'
import SubscriptionSearch from '@/components/SubscriptionSearch'

export default {
  data () {
    return {
      pageResponse: {}
    }
  },

  computed: {
    subscriptionUrl () {
      const url = this.apiUrl((this.userId ? '/users/' + this.userId : '/admin') + '/subscriptions')
      return url
    }
  },

  props: {
    noKey: {
      type: Boolean,
      default: false
    },

    noNav: {
      type: Boolean,
      default: false
    },

    noSearch: {
      type: Boolean,
      default: false
    },

    userId: {
      type: [ Number, String ],
      default: undefined
    }
  },

  components: {
    'pagination': Pagination,
    'subscription-nav': SubscriptionNav,
    'subscription-search': SubscriptionSearch
  },

  created () {
    this.$on('searchComplete', this.onPageSuccess)
  },

  methods: {
    isGift (item) {
      return item.purchase.data ? item.purchase.data.attributes.gift : item.purchase.attributes.gift
    },

    onPageSuccess (resp) {
      this.pageResponse = resp
    },

    formattedSubscriptionDate (d) {
      return this.$root.displayDateTimeFmt(d)
    },

    subscriptionClass (status) {
      let className

      switch (status) {
        case 'active':
          className = 'success'
          break
        case 'future':
          className = 'primary'
          break
        case 'expiry_looming':
          className = 'warning'
          break
        case 'expired':
          className = 'dark'
          break
        case 'expiry_imminent':
          className = 'danger'
          break
      }

      return 'list-group-item-' + className
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/components/Subscriptions.vue